import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { UserService } from './core/user/services/user.service'

@Component({
    selector: 'aio-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.sass'],
    standalone: false
})
export class AppComponent {
  public title = 'all-in-one'
  private privateLang
  get lang(): string {
    if (!this.privateLang) {
      this.privateLang = localStorage.getItem('lang') || 'fr'
    }
    return this.privateLang
  }

  set lang(value: string) {
    localStorage.setItem('lang', value)
    this.privateLang = value
    this.translate.use(this.privateLang)
  }

  constructor(
    private translate: TranslateService,
    public userService: UserService
  ) {
    this.translate.setDefaultLang(this.lang)
    this.translate.use(this.lang)
  }

  public selectLanguage(value: string) {
    this.lang = value
  }
}
